import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { EnvelopeSimple, ArrowLeft } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [debug, setDebug] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email: email.toLowerCase().trim() });
      setSent(true);
      if (data.simulated) {
        setDebug({ token: data.debug_token, url: data.debug_reset_url, error: data.mail_error });
        if (data.mail_error) {
          toast.message("⚠️ Resend retornou erro — fluxo de teste habilitado", {
            description: data.mail_error,
            duration: 15000,
          });
        } else {
          toast.message("📧 E-mail simulado (Resend não configurado no servidor)", {
            description: "Link de redefinição abaixo para teste.",
            duration: 12000,
          });
        }
      } else {
        toast.success("Instruções enviadas para seu e-mail.");
      }
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-8" data-testid="forgot-password-page">
      <Link to="/" className="inline-flex items-center gap-1 text-sm text-slate-500 mb-4 hover:text-[#004E98]" data-testid="back-link">
        <ArrowLeft size={16} weight="bold" /> Voltar
      </Link>
      <div className="aj-card p-6">
        <div className="w-14 h-14 rounded-full bg-[#004E98]/10 flex items-center justify-center">
          <EnvelopeSimple size={28} weight="duotone" color="#004E98" />
        </div>
        <h1 className="font-heading text-2xl font-black mt-3">Esqueci minha senha</h1>
        <p className="text-sm text-slate-600 mt-1 mb-4">
          Informe o e-mail cadastrado e enviaremos um link para redefinir sua senha.
        </p>

        {!sent ? (
          <form onSubmit={submit} className="space-y-3">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seu@email.com"
              className="aj-input"
              data-testid="forgot-email-input"
            />
            <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="forgot-submit">
              {busy ? "Enviando..." : "Enviar instruções"}
            </button>
          </form>
        ) : (
          <div data-testid="forgot-sent">
            <p className="text-sm text-slate-600 mb-3">
              ✅ Se o e-mail estiver cadastrado, você receberá as instruções em alguns minutos.
            </p>
            {debug && (
              <div className="aj-card p-3 bg-slate-50 border-dashed text-xs space-y-2">
                <div className="font-bold text-[11px] uppercase tracking-wider text-slate-500">
                  {debug.error ? "Resend retornou erro — modo teste" : "Modo simulado (MVP)"}
                </div>
                {debug.error && (
                  <div className="text-red-700 break-words">{debug.error}</div>
                )}
                <Link
                  to={`/redefinir-senha?token=${debug.token}`}
                  className="text-[#004E98] font-semibold break-all"
                  data-testid="debug-reset-link"
                >
                  Abrir link de redefinição
                </Link>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
